import { SEND_WHATSAPP_MSG, SEND_WHATSAPP_MSG_FAILED, SEND_WHATSAPP_MSG_SUCCESS } from "./constants"

export const sendWhatsAppMsg = (payload) =>({
    type: SEND_WHATSAPP_MSG,
    payload
})

export const sendWhatsAppMsgSuccess = payload =>({
    type: SEND_WHATSAPP_MSG_SUCCESS,
    payload
})

export const sendWhatsAppMsgFailed = payload =>({
    type: SEND_WHATSAPP_MSG_FAILED,
    payload
})